import React from 'react';
import { View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import I18n from '../../lib/i18n';
import type { PaymentMeanType } from 'digicel-kaizen-library';

const PaymentMeanChangeDetails = ({ type, characteristics }: Props) => {
  if (!type) return null;

  const isCreditCard = type === 'CREDIT_CARD' || characteristics?.type === 'CREDIT_CARD';
  if (isCreditCard) {
    return (
      <View>
        <Text>{I18n.t(`paymentMean.CREDIT_CARD.name`)}</Text>
        {!!characteristics.cardNumber && (
          <Text>{I18n.t(`paymentMean.CREDIT_CARD.mask`, { mask: characteristics.cardNumber.substr(-4) })}</Text>
        )}
      </View>
    );
  }

  const isPaypal = characteristics?.type === 'PAYPAL';
  if (isPaypal) {
    return (
      <View>
        <Text>{I18n.t(`paymentMean.PAYPAL.name`)}</Text>
      </View>
    );
  }

  return (
    <View>
      <Text>{I18n.t(`paymentMean.${type}.name`)}</Text>
    </View>
  );
};

type Props = {
  type: PaymentMeanType.type,
  characteristics: PaymentMeanType.characteristics,
};

export default PaymentMeanChangeDetails;
